var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockforeverLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 69,
    viewBox: "0 0 47 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15746 36.2521C3.13869 34.6888 3.10618 30.8106 3.16776 26.0172C2.69205 10.9797 8.40066 0 23.6236 0C35.0409 0 44.0795 6.20593 43.8417 26.0172V36.2855C45.8365 39.4636 46.9781 43.1525 46.9781 47.0868C46.9781 59.028 36.4617 68.7083 23.489 68.7083C10.5164 68.7083 0 59.028 0 47.0868C0 43.1387 1.14959 39.4377 3.15746 36.2521ZM34.0361 27.7622C33.9582 25.7541 33.8274 23.5964 33.6137 21.4821C33.3726 19.0952 31.7109 8.83152 23.6236 8.83152C15.5363 8.83152 13.1578 13.3666 12.4443 21.4821C12.219 23.7117 12.1913 25.9898 12.2634 28.0895C15.5985 26.4161 19.4231 25.4652 23.489 25.4652C27.2818 25.4652 30.8646 26.2927 34.0361 27.7622Z",
    fill: "#0A64BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5273 46.6895C28.8884 45.6319 29.7528 44.0498 29.7528 42.2819C29.7528 39.0975 26.9484 36.5161 23.489 36.5161C20.0297 36.5161 17.2253 39.0975 17.2253 42.2819C17.2253 44.24 18.2857 45.9701 19.9067 47.0122C19.8725 47.1151 19.8462 47.2219 19.8288 47.3321L18.6356 54.8636C18.4432 56.0778 19.3816 57.1765 20.6109 57.1765H27.3042C28.5692 57.1765 29.5165 56.0169 29.264 54.7773L27.7298 47.2458C27.6894 47.0471 27.6203 46.8604 27.5273 46.6895Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.23 25.4651L3.13708 32.6723L3.15804 36.2518L12.2666 28.0837L12.23 25.4651Z",
    fill: "#0A5095"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M44.6293 47.327C44.4919 56.9366 35.4946 62.4621 35.4946 62.4621C35.4946 62.4621 42.8996 56.2159 43.3243 47.327C43.7146 39.1589 35.4946 31.7114 35.4946 31.7114C35.4946 31.7114 44.7666 37.7174 44.6293 47.327Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3983 3.60387C8.76721 6.65586 6.52472 12.733 6.52472 12.733C6.52472 12.733 10.4396 7.44767 16.1813 4.80504C21.9231 2.1624 27.4039 2.40267 27.4039 2.40267C27.4039 2.40267 22.0295 0.551869 15.3983 3.60387Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockforeverLogo);
export default __webpack_public_path__ + "static/media/blockforever-logo.e8b06f24ea4c20302238d06349fe2e1f.svg";
export { ForwardRef as ReactComponent };